enum ActionTypes {
  SCHEDULE_ADD_REACTION = "app/emojiReactions/SCHEDULE_ADD_REACTION",
}

export default ActionTypes;
